module.exports = __webpack_public_path__ + "static/media/background4.2a477e38.jpg";